module.exports = __webpack_public_path__ + "static/media/ic_categories_car.74b1aecf.svg";